import { Injectable } from '@angular/core';
import { getTimezone } from '../../dataprotection-common/utils';
import { HttpUtils } from '../../../../../common/http/http-utils';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class Service {
  value = '';

  constructor(public http: HttpClient) {
  }

  updateRestorePointsVapp(vdcId, vappId, backupId, newExpiryDate) {
    let payload = {"expirationTS": newExpiryDate};
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/' + vdcId + '/vapp/' + vappId + '/backup/' + backupId + '?timezone=' + encodeURIComponent(getTimezone());
    return this.http
      .put(url, JSON.stringify(payload))
      .map(
        (res: any) => this.value = res
      );
  }

  updateRestorePointsDeletedVapp(vdcId, vappId, backupId, newExpiryDate) {
    //newExpiryDate would be in the format "2017-05-19 06:41:43"
    let payload = {"expirationTS": newExpiryDate};
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/' + vdcId + '/deletedVApp/' + vappId + '/backup/' + backupId + '?timezone=' + encodeURIComponent(getTimezone());
    return this.http
      .put(url, JSON.stringify(payload))
      .map(
        (res: any) => this.value = res
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/update-restore/update-restore.service.ts